import React from "react"
import "./css/Header.css"
import Logo from "../assets/logo.png"
import aboutimage from "../assets/aboutphoto.jpeg"
import treeseedling from "../assets/treeseedling.jpeg"
import treeshowcase from "../assets/treeshowase.jpg"

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <img src={Logo} alt="Jambo Tree Kenya" className="hero-logo" />
            <h1 className="hero-title">
              Leading Africa's <span className="text-green">Green Revolution</span>
            </h1>
            <p className="hero-description">
              Jambo Tree Kenya provides Nature-based solutions that seek to help address climate change 
              by cultivating indigenous African seedlings and trees. We supply local & worldwide export 
              markets, supporting conservation efforts & Kenya's plan to plant 15 billion trees by 2032.
            </p>
            <div className="hero-buttons">
              <a href="/about" className="btn btn-primary">
                Learn More
              </a>
              <a href="/work-with-us" className="btn btn-secondary">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3 className="stat-number">200+</h3>
              <p className="stat-label">Tree Species</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">8 Years</h3>
              <p className="stat-label">Experience</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">5 Countries</h3>
              <p className="stat-label">Global Projects</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">15B</h3>
              <p className="stat-label">Trees Goal 2032</p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="vision-mission-section">
        <div className="container" style={{display: 'block !important'}}>
          <div className="section-header">
            <h2 className="section-title">Our Vision & Mission</h2>
            <div className="title-underline"></div>
          </div>
          <div className="vision-mission-grid">
            <div className="vision-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="card-title">Vision</h3>
              <p className="card-description">
                To become a leading consultancy firm in Africa's Green Space
              </p>
            </div>
            <div className="mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="card-title">Mission</h3>
              <p className="card-description">
                Support to build a stable, sustainable & innovative climate resilient ecosystem in Africa
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Overview Section */}
      <section className="about-overview-section">
        <div className="container" style={{display: 'block'}}>
          <div className="about-content">
            <div className="about-text">
              <h2 className="section-title">About Jambo Tree Kenya</h2>
              <div className="title-underline"></div>
              <p className="about-description">
                Jambo Tree was set up in 2017, as an innovative, women-led initiative that provides 
                Nature-based solutions that seek to help address climate change by cultivating indigenous 
                African tree seedlings and supplying to local & worldwide export markets. Our consultancy 
                services in Carbon markets & ESG offer transformative change across policy, technology, 
                finance, and community behaviour.
              </p>
              <div className="about-highlights">
                <div className="highlight-item">
                  <h4>Our Farm</h4>
                  <p>Located at the foot of Mount Kilimanjaro in Kimana, Loitoktok area of Kajiado County, Kenya</p>
                </div>
                <div className="highlight-item">
                  <h4>Our Focus</h4>
                  <p>African indigenous tree varieties including Acacia and Adansonia (Baobab) that are drought tolerant</p>
                </div>
              </div>
              <div className="core-values">
                <div className="value-tag">Sustainability</div>
                <div className="value-tag">Integrity</div>
                <div className="value-tag">Collaboration</div>
                <div className="value-tag">Diversity</div>
                <div className="value-tag">Inclusion</div>
              </div>
              <a href="/about" className="btn btn-primary">Learn More About Us</a>
            </div>
            <div className="about-images">
              <div className="main-image">
                <img src={aboutimage} alt="Our team at work" />
              </div>
              <div className="image-grid">
                <img src={treeseedling} alt="Tree seedlings" />
                <img src={treeshowcase} alt="Mature trees" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Services</h2>
            <div className="title-underline"></div>
            <p className="section-description">
              We provide comprehensive consultancy services to help organizations achieve their sustainability goals and climate commitments.
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="service-title">Carbon Project Development</h3>
              <p className="service-description">
                Expert guidance in developing projects that avoid, reduce, or remove GHG emissions for carbon credit markets.
              </p>
              <a href="/work-with-us" className="service-link">Learn More →</a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                </svg>
              </div>
              <h3 className="service-title">ESG & Sustainability Reporting</h3>
              <p className="service-description">
                Comprehensive green audits and ESG analysis to assess and improve your environmental impact.
              </p>
              <a href="/work-with-us" className="service-link">Learn More →</a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
                </svg>
              </div>
              <h3 className="service-title">Climate Risk & Adaptation</h3>
              <p className="service-description">
                High-level services to assess climate risks and develop adaptation strategies for resilient operations.
              </p>
              <a href="/work-with-us" className="service-link">Learn More →</a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="service-title">Agro-Forestry & Tree Planting</h3>
              <p className="service-description">
                Indigenous tree seedling cultivation and supply for climate mitigation projects and international markets.
              </p>
              <a href="/products" className="service-link">View Products →</a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                </svg>
              </div>
              <h3 className="service-title">Capacity Building & Training</h3>
              <p className="service-description">
                Comprehensive training programs on Carbon Markets, ESG reporting, and environmental management systems.
              </p>
              <a href="/work-with-us" className="service-link">Learn More →</a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="service-title">GHG Emissions Calculation</h3>
              <p className="service-description">
                Accurate measurement of corporate carbon footprint including Scope 1, 2 & 3 emissions analysis.
              </p>
              <a href="/work-with-us" className="service-link">Learn More →</a>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects Section */}
      <section className="projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Key Portfolio Projects</h2>
            <div className="title-underline"></div>
          </div>
          <div className="projects-grid">
            <div className="project-card">
              <div className="project-meta">
                <span className="project-year">2025</span>
                <span className="project-location">KENYA</span>
              </div>
              <h3 className="project-title">Carbon Markets Assessment</h3>
              <p className="project-description">
                Comprehensive assessment of Kenya's Carbon Markets Ecosystem commissioned by the Capital Markets Authority, 
                Treasury, Government of Kenya. Achieved 92% technical score, beating major firms like KPMG & Ernst & Young.
              </p>
              <div className="project-highlights">
                <span className="highlight-tag">Government Commission</span>
                <span className="highlight-tag">92% Technical Score</span>
              </div>
            </div>
            <div className="project-card">
              <div className="project-meta">
                <span className="project-year">2023</span>
                <span className="project-location">BRAZIL</span>
              </div>
              <h3 className="project-title">Environmental Management System</h3>
              <p className="project-description">
                Designed EMS for Porte Alegre & Rio Grande Ports, including Blue Economy projects assessment, 
                CO2 monitoring, and Green Shipping Corridor partnerships.
              </p>
              <div className="project-highlights">
                <span className="highlight-tag">Blue Economy</span>
                <span className="highlight-tag">ISO 14000</span>
              </div>
            </div>
            <div className="project-card">
              <div className="project-meta">
                <span className="project-year">2023</span>
                <span className="project-location">KENYA</span>
              </div>
              <h3 className="project-title">Faith & Restoration Program</h3>
              <p className="project-description">
                Partnership with WWF Kenya for community restoration in Amboseli landscape, leading to first 
                Green Mosques & churches initiatives and linking farmers to Voluntary Carbon Markets.
              </p>
              <div className="project-highlights">
                <span className="highlight-tag">WWF Partnership</span>
                <span className="highlight-tag">Community Impact</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Preview Section */}
      <section className="team-preview-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Meet Our Leadership Team</h2>
            <div className="title-underline"></div>
          </div>
          <div className="team-preview">
            <div className="team-summary">
              <h3>Expert Leadership</h3>
              <p>
                Our diverse team combines expertise in environmental science, finance, policy, and project management 
                to deliver comprehensive climate solutions across Africa and beyond.
              </p>
              <div className="team-stats">
                <div className="team-stat">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Team Members</span>
                </div>
                <div className="team-stat">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Years Combined Experience</span>
                </div>
              </div>
              <a href="/team" className="btn btn-primary">Meet Our Team</a>
            </div>
            <div className="team-highlight">
              <div className="leadership-focus">
                <h4>Women-Led Initiative</h4>
                <p>Founded and led by women pioneers in Africa's green economy, driving innovation in climate solutions.</p>
              </div>
              <div className="expertise-areas">
                <div className="expertise-tag">Environmental Science</div>
                <div className="expertise-tag">Carbon Markets</div>
                <div className="expertise-tag">ESG Reporting</div>
                <div className="expertise-tag">Project Management</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Start Your Sustainability Journey?</h2>
            <p className="cta-description">
              Join us in building a stable, sustainable, and innovative climate-resilient ecosystem in Africa. 
              Let's work together to create positive environmental impact.
            </p>
            <div className="cta-buttons">
              <a href="/work-with-us" className="btn btn-primary">
                Get Started Today
              </a>
              <a href="/contact" className="btn btn-secondary">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default LandingPage